import { render, staticRenderFns } from "./SisEventsAdmin.vue?vue&type=template&id=5f747d32&scoped=true"
import script from "./SisEventsAdmin.vue?vue&type=script&lang=js"
export * from "./SisEventsAdmin.vue?vue&type=script&lang=js"
import style0 from "./SisEventsAdmin.vue?vue&type=style&index=0&id=5f747d32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f747d32",
  null
  
)

export default component.exports